


import { useRef } from "react";

export type printFileProps = {
  urlPdf: string;
};

export const useFilePrint = () => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  const printFile = async ({ urlPdf }: printFileProps) => {
    try {
      const response = await fetch(urlPdf);
      if (!response.ok) throw new Error("Error al obtener el PDF");

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));

      let iframe = iframeRef.current;

      if (!iframe) {
        iframe = document.createElement("iframe");
        iframe.style.display = "none";
        document.body.appendChild(iframe);
        iframeRef.current = iframe;
      }

      iframe.src = blobUrl;

      iframe.onload = () => {
        setTimeout(() => {
          iframe?.contentWindow?.focus();
          iframe?.contentWindow?.print();

          URL.revokeObjectURL(blobUrl);
        }, 200); // da tiempo a que cargue el PDF antes de imprimir
      };
    } catch (error) {
      console.error("Error al imprimir", error);
    }
  };

  return {
    printFile,
  };
};
